namespace TabAurous.Common {
    export interface LaborRateResponse extends Serenity.ServiceResponse {
        RateType?: number;
        AttributeId?: number;
        PriceListId?: number;
        ProductTypeId?: number;
        ItemTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneSizeId?: number;
        ShapeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        QualityId?: number;
        StoneColorId?: number;
        SettingId?: number;
        ProcessId?: number;
        FromWt?: number;
        ToWt?: number;
        PurStdLabour?: number;
        SaleStdLabour?: number;
        Amount?: number;
        MinLabour?: number;
        MaxLabour?: number;
        ProductId?: number;
        ItemType?: string;
        SubCategoryName?: string;
        Attribute?: string;
        FromDate?: string;
        ToDate?: string;
        PurStdRate?: number;
        SaleStdRate?: number;
        MarkUp?: number;
        ProcessName?: string;
        ProcessTypeId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        CalcOnId?: number;
        IsCustomerItem?: boolean;
        MetalId?: number;
        CalculateTo?: number;
        Pieces?: number;
        Weight?: number;
    }
}
